define('formkit/view/form.object/common/preview.general.view',['require','exports','module','uikit/uikit','../../../templates'],function(require, exports, module) {
  var UIKit     = require('uikit/uikit');
  var Templates = require('../../../templates');

  var PreviewGeneralView = UIKit.ItemView.extend({
    template: Templates.App['form.object.content.preview.general'],

    internalViewOptions: {
      labelView: function () {
        return {
          type: UIKit.Text,
          className: 'previewLabel',
          model: this.model,
          bindings: {
            text: 'label'
          }
        }
      },
      titleView: function () {
        return {
          type: UIKit.Text,
          className: 'previewText',
          model: this.model,
          bindings: {
            text: 'text'
          }
        }
      },
      descriptionView: function () {
        return {
          type: UIKit.Text,
          className: 'previewDescription',
          color: 'muted',
          model: this.model,
          renderAsHtml: true,
          bindings: {
            text: 'description'
          }
        }
      },
      requiredQuestionView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          color: 'red',
          text: '*',
          bindings: {
            visible: 'required'
          }
        }
      }
    },

    getGeneralViewOptionsByProperty: function (property) {
      return {
        model: this.model,
        bindings: this.getBindingsFromModelAttributeMap(property)
      }
    },

    getBindingsFromModelAttributeMap: function (property) {
      return {
        text: this.getOption('modelAttributeMap')? this.getOption('modelAttributeMap')[property]: property
      }
    }
  });

  module.exports = PreviewGeneralView;
});

